module.exports = __webpack_public_path__ + "static/media/mobile-view-group-image.b9bebcad.png";